export default function Disclaimer() {
  return (
    <div
      className={`font-open-sans text-primary-midBlack text-opacity-80  py-10 `}
    >
      <p className="text-xl font-bold">Privacy Statements</p>

      <p className="mt-4">
        Camera permission is only to track and correct your posture for
        performance measurement. We do not record any images or videos. We do
        not use your personal information for any kind of affiliate marketing
        and promotions.{" "}
      </p>
      <p className="mt-4">
        People with any medical/ biomechanical condition are advised to consult
        their doctor or speak to a getactyv expert before initiating any
        recommended program.{" "}
      </p>
      <p className="mt-4">
        We do not assume any risk/liability for people who perform any routine,
        program, or games that are not suited for them, or are performed by them
        without appropriate consultation.
      </p>
      <p className="mt-4">
        We are not responsible for any injuries, or any medical condition that
        may arise owing to the performance of any of the exercises, routines, or
        programs since we are not examining the user for any existing, or
        prevailing conditions and the consequences thereof.
      </p>
      <p className="mt-4">
        We are a purely tech-enabled platform to track incorrect posture, and
        guide and recommend suited programs based on the answers provided by the
        user at the time of sign-up. We shall not be liable for any errors or
        omissions on account of incorrect inputs, postures performed despite
        corrections called out, and exercises performed in settings beyond our
        control.
      </p>

      <p className="mt-4">
        Read more about our{" "}
        <a href="https://getactyv.com/privacy" className="text-blue-900">
          privacy policies
        </a>{" "}
        and Terms and Conditions
      </p>
    </div>
  );
}
